module.exports = __webpack_public_path__ + "static/img/fgbg2-3.9a2fb65.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/2/fgbg2-3.png
// module id = 194
// module chunks = 0